export const SETLAYANAN = "SETLAYANAN";
export const RESETLAYANAN = "RESETLAYANAN";
export const RESETDETAILSLAYANAN = "RESETDETAILSLAYANAN";